var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaire-page"},[_c('image-selector',{attrs:{"options":_vm.currentMoods,"width":"32.5%","element-class":"-image","borders":false},on:{"changed":_vm.onToNext},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }